<template>
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <h4>Detalle de oferta de botón de pánico</h4>
      </div>
    </div>
    <br />
    <hr />
    <div class="row">
      <div class="col-3">ID</div>
      <div class="col-9">
        <input type="text" disabled v-model="formDetail.idtiempoextraoferta" />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">Management Unit</div>
      <div class="col-9">
        <input type="text" v-model="formDetail.management_unit" disabled />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">Fecha</div>
      <div class="col-9">
        <input type="text" v-model="formDetail.fecha_creacion" disabled />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">Fecha de Oferta</div>
      <div class="col-9">
        <input type="text" v-model="formDetail.fecha_oferta" disabled />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">Hora Inicio</div>
      <div class="col-9">
        <input type="text" v-model="formDetail.hora_inicio" disabled />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">Hora Final</div>
      <div class="col-9">
        <input type="text" v-model="formDetail.hora_final" disabled />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">Slots</div>
      <div class="col-9">
        <input type="text" v-model="formDetail.slots" disabled />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">Longitud Mínima</div>
      <div class="col-9">
        <select v-model="formDetail.longitud_minima" disabled>
          <option disabled value="">Seleccionar...</option>
          <option value="1800">00:30</option>
          <option value="3600">01:00</option>
          <option value="5400">01:30</option>
          <option value="7200">02:00</option>
          <option value="9000">02:30</option>
          <option value="10800">03:00</option>
          <option value="12600">03:30</option>
          <option value="14400">04:00</option>
          <option value="16200">04:30</option>
          <option value="18000">05:00</option>
          <option value="19800">05:30</option>
          <option value="21600">06:00</option>
          <option value="23400">06:30</option>
          <option value="25200">07:00</option>
          <option value="27000">07:30</option>
          <option value="28800">08:00</option>
          <option value="30600">08:30</option>
          <option value="32400">09:00</option>
          <option value="34200">09:30</option>
          <option value="36000">10:00</option>
          <option value="39600">10:30</option>
          <option value="41400">11:00</option>
          <option value="43200">11:30</option>
          <option value="45000">12:00</option>
        </select>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">Tipo de Actividad</div>
      <div class="col-9">
        <input type="text" v-model="formDetail.tipo_actividad" disabled />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">Oferta encendida</div>
      <div class="col-9">
        <input type="checkbox" v-model="formDetail.oferta_encendida" />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">Regla 48+</div>
      <div class="col-9">
        <input type="checkbox" v-model="formDetail.regla_48" disabled />
      </div>
    </div>
    <hr />
    <div class="row pl-2" style="overflow-x: auto">
      <strong style="color: blue">Detalle de Slots</strong>
      <br /><br />
      <table class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
        <tr class="header-table">
          <th>Horas</th>
          <th v-for="hora in horas" :key="hora">
            {{ hora }}
          </th>
        </tr>
        <tr v-if="slots && 'requeridos' in slots">
          <td>
            <strong>Slots Requeridos</strong>
          </td>
          <td v-for="(x, idx) in slots.requeridos" :key="idx">
            {{ x }}
          </td>
        </tr>
        <tr v-if="slots && 'ocupados' in slots">
          <td>
            <strong>Slots Ocupados</strong>
          </td>
          <td v-for="(x, idx) in slots.ocupados" :key="idx">
            {{ x }}
          </td>
        </tr>
        <tr v-if="slots && 'diferencia' in slots">
          <td>
            <strong>Diferencia</strong>
          </td>
          <td v-for="(x, idx) in slots.diferencia" :key="idx">
            {{ x }}
          </td>
        </tr>
      </table>
    </div>
    <br />
    <div class="row pl-2" v-if="this.formDetail.regla_48">
      <strong style="color: blue">Solicitudes de +48 Horas</strong>
      <br /><br />
      <table class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
        <tr class="header-table">
          <th>ID Agente</th>
          <th>Nombre</th>
          <th>Horas Solicitadas</th>
        </tr>
        <tr v-for="solicitud in solicitudes" :key="solicitud.idtiempoextrasolicitud">
          <td>{{ solicitud.idagente }}</td>
          <td>{{ solicitud.nomagente_sistema }}</td>
          <td>
            {{ solicitud.horas }}
            <span class="pl-3">
              <button class="btn btn-sm btn-success" style="width: 80px" @click="Autorizar_Solicitud(solicitud.idtiempoextrasolicitud)">Autorizar</button>
              <button class="btn btn-sm btn-danger" style="width: 80px" @click="Rechazar_Solicitud(solicitud.idtiempoextrasolicitud)">Rechazar</button>
            </span>
          </td>
        </tr>
      </table>
    </div>
    <br />
    <div class="text-right">
      <button class="btn btn-sm btn-success" style="width: 80px" @click="Guardar_Detalle_Oferta()">Guardar</button>
      <button class="btn btn-sm btn-danger" style="width: 80px" @click="Cancelar_Detalle_Oferta()">Cancelar</button>
    </div>
    <br />
  </div>
</template>

<script>
import moment from "moment-timezone";
import * as _ from "lodash";

import GeneralMixin from "@/components/mixins/General";
import { VersionIxeEnum } from "@/utils/enums/VersionIxeEnum";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [GeneralMixin],
  data: function () {
    return {
      idoferta: null,
      formDetail: {
        management_unit: "",
        fecha_creacion: "",
        hora_inicio: "",
        hora_final: "",
        slots: "",
        longitud_minima: "",
        tipo_actividad: "",
        oferta_encendida: false,
        regla_48: false,
      },
      slots: null,
      horas: [],
      solicitudes: [],
    };
  },
  activated() {
    this.Init();
  },
  methods: {
    ...mapActions("horarios", ["setComponent"]),
    Obtener_Url(url) {
      return (this.usuario.sistema == VersionIxeEnum.R3 ? "r3/" : "") + url;
    },
    Init() {
      this.idoferta = this.menu.item;
      if (this.idoferta) {
        const url = this.Obtener_Url("tiempoExtra/ofertas/detalle/" + this.idoferta);
        this.$http
          .get(url, {
            headers: this.get_request_headers({
              accesstoken: localStorage.getItem("tokenmsal"),
            }),
          })
          .then((response) => response.json())
          .then((oferta) => {
            this.formDetail = {
              idtiempoextraoferta: oferta.idtiempoextraoferta,
              management_unit: oferta.mu,
              fecha_creacion: moment.utc(oferta.fecha_creacion).tz("America/Monterrey").format("YYYY-MM-DD HH:mm"),
              fecha_oferta: oferta.fecha_inicio.split(" ")[0],
              fecha_inicio: oferta.fecha_inicio,
              fecha_fin: oferta.fecha_fin,
              hora_inicio: oferta.fecha_inicio.split(" ")[1],
              hora_final: oferta.fecha_fin.split(" ")[1],
              slots: oferta.capacidad,
              longitud_minima: oferta.longitud_minima,
              tipo_actividad: oferta.idactividad,
              oferta_encendida: parseInt(oferta.esta_activa),
              regla_48: parseInt(oferta.aplica_48_horas),
            };
            // Obtiene el rango de horas
            var hora_inicio = moment(this.formDetail.hora_inicio, "HH:mm").diff(moment().startOf("day"), "seconds");
            var hora_final = moment(this.formDetail.hora_final, "HH:mm").diff(moment().startOf("day"), "seconds");
            var seconds = hora_inicio;

            this.slots = oferta.slots.reduce(
              function (acc, slot, index) {
                const capacidad = slot["capacidad"];
                const ocupados = slot["ocupados"];
                acc["requeridos"].push(capacidad);
                acc["ocupados"].push(ocupados);
                acc["diferencia"].push(capacidad - ocupados);
                return acc;
              },
              {
                requeridos: [],
                ocupados: [],
                diferencia: [],
              }
            );

            this.horas = oferta.slots.map((slot) => {
              const fecha = moment(this.formDetail.fecha_inicio);
              const fecha_inicio = moment(fecha.format("YYYY-MM-DD") + " " + slot["hora_inicio"]);
              const fecha_fin = moment(fecha.format("YYYY-MM-DD") + " " + slot["hora_fin"]);
              return fecha_inicio.format("HH:mm") + "-" + fecha_fin.format("HH:mm");
            }, this);
            this.solicitudes = oferta.solicitudes;
          });
      } else {
        toastr.clear();
        toastr.error("Oferta inválida");
      }
    },
    Autorizar_Solicitud(idtiempoextrasolicitud) {
      const url = this.Obtener_Url("tiempoExtra/ofertas/solicitud/evaluar/" + idtiempoextrasolicitud);
      this.$http
        .put(
          url,
          {
            aprobar: true,
          },
          {
            headers: this.get_request_headers({
              accesstoken: localStorage.getItem("tokenmsal"),
            }),
          }
        )
        .then((result) => {
          swal("Solicitud Autorizada", "La solicitud fue autorizada con exito", "success");
          this.Init();
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          if (_.has(error, "body.mensaje")) {
            swal("Error", error.body.mensaje, "error");
          } else {
            swal("Error", "Ha ocurrido un error inesperado", "error");
          }
        });
    },
    Rechazar_Solicitud(idtiempoextrasolicitud) {
      const url = this.Obtener_Url("tiempoExtra/ofertas/solicitud/evaluar/" + idtiempoextrasolicitud);
      this.$http
        .put(
          url,
          {
            aprobar: false,
          },
          {
            headers: this.get_request_headers({
              accesstoken: localStorage.getItem("tokenmsal"),
            }),
          }
        )
        .then((result) => {
          swal("Solicitud Rechazada", "La solicitud fue rechazada", "success");
          this.solicitudes = this.solicitudes.filter((s) => s.idtiempoextrasolicitud != idtiempoextrasolicitud);
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          if (_.has(error, "body.mensaje")) {
            swal("Error", error.body.mensaje, "error");
          } else {
            swal("Error", "Ha ocurrido un error inesperado", "error");
          }
        });
    },
    Guardar_Detalle_Oferta() {
      const url = this.Obtener_Url("tiempoExtra/ofertas/" + this.idoferta);
      this.$http
        .put(
          url,
          {
            esta_activa: this.formDetail.oferta_encendida,
          },
          {
            headers: this.get_request_headers({
              accesstoken: localStorage.getItem("tokenmsal"),
            }),
          }
        )
        .then((result) => {
          swal("Solicitud Actualizada", "La solicitud fue actualizada con exito", "success");
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          if (_.has(error, "body.mensaje")) {
            swal("Error", error.body.mensaje, "error");
          } else {
            swal("Error", "Ha ocurrido un error inesperado", "error");
          }
        });
    },
    Cancelar_Detalle_Oferta() {
      this.setComponent({ component: "home" });
    },
  },
  computed: {
    usuario() {
      return this.$store.state.menu.usuario;
    },
    ...mapGetters("horarios", ["menu"]),
  },
};
</script>
